import { Seo } from '../components/Seo';
import { LEGAL_PAGES } from '../lib/config';
import { SITE } from '../lib/config';

const page = LEGAL_PAGES.find((p) => p.path === '/contact')!;

export function ContactPage() {
  return (
    <>
      <Seo page={page} />
      <section className="mx-auto max-w-2xl px-4 py-12 text-center sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold text-text-primary sm:text-4xl">{page.h1}</h1>
        <p className="mt-3 text-lg text-text-secondary">
          Have a question or feedback? Send us an email and we’ll get back to you as soon as possible.
        </p>

        <div className="mt-8 rounded-2xl border border-border-subtle bg-bg-elevated p-6 text-left shadow-sm sm:p-8">
          <h2 className="text-lg font-semibold text-text-primary">Email</h2>
          <p className="mt-2 text-text-secondary">
            <a
              href={`mailto:${SITE.supportEmail}`}
              className="text-primary hover:text-primary-hover hover:underline"
            >
              {SITE.supportEmail}
            </a>
          </p>

          <h2 className="mt-6 text-lg font-semibold text-text-primary">Common questions</h2>
          <ul className="mt-2 list-inside list-disc space-y-1 text-text-secondary">
            <li>Free plan: 2 images per day, 2× upscale</li>
            <li>Pro plan: 100 images per month, 2× and 4× upscales</li>
            <li>Supported formats: JPG, PNG, WebP</li>
          </ul>

          <p className="mt-6 text-sm text-text-secondary">
            Typical response time: 1–2 business days.
          </p>
        </div>
      </section>
    </>
  );
}
